import { render, staticRenderFns } from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=template&id=0e27e784&scoped=true&"
import script from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=style&index=0&id=0e27e784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e27e784",
  null
  
)

export default component.exports